export const barColors: string[] = [
  '#4572A7', // blue
  '#AA4643', // red
  '#89A54E', // green
  '#DB843D', // orange
  '#80699B', // purple
  '#92A8CD', // light blue
  '#3D96AE', // teal blue
  '#B5CA92', // light green
  '#A47D7C', // brown

  // New Colors
  '#696969', // Dim Gray
  '#dcdcdc', // Gainsboro
  '#7f0000', // Maroon 2
  '#808000', // Olive
  '#483d8b', // Dark Slate Blue
  '#008000', // Green
  '#008b8b', // Dark Cyan
  '#4682b4', // Steel Blue
  '#000080', // Navy
  '#9acd32', // Yellow Green
  '#8fbc8f', // Dark Sea Green
  '#800080', // Purple
  '#ff4500', // Orange Red
  '#ffa500', // Orange
  '#ffff00', // Yellow
  '#0000cd', // Medium Blue
  '#00ff7f', // Spring Green
  '#e9967a', // Dark Salmon
  '#dc143c', // Crimson
  '#00ffff', // Aqua
  '#da70d6', // Orchid
  '#ff00ff', // Fuchsia
  '#1e90ff', // Dodger Blue
  '#db7093', // Pale Violet Red
  '#f0e68c', // Khaki
  '#ff1493', // Deep Pink
  '#7b68ee', // Medium Slate Blue
];

export const white = '#FFFFFF';
export const black = '#000000';
